import {_str,DATA_UTIL} from 'h2g-test-results/js/util';
import H2GDIALOG from 'h2g-material/dialogs/h2g-dialog';
import DEVICELIST from './device-list';

 var DEVICEDETAILS = {
  init : function($scope,$stateParams){
   var dl = DEVICELIST.getDeviceList();
   var p = C11N.is_portal?$stateParams.p:($stateParams && $stateParams.p && JSON.parse($stateParams.p));
   //L.trace('inside-submodule-p.id--'+p.id);
   var details = dl.find(function(x){return x.MAC==p.id});
   //L.trace('devicedetails--'+JSON.stringify(details));
   $scope.connection_type_map = {1:_str("conn_type_lan_str"),2:_str("conn_type_wifi_str"),3:_str("conn_type_others_str")};
   $scope.device_type_map = {1:"gateway",2:"access_point",3:"printer",4:"media_server",5:"tv_receiver",
    100:"computer",101:"gaming_console",102:"mobile",103:"phone",104:"tablet",
    // missing device types are added here with custom numbers for mapping
    901:"laptop",902:"desktop"
   };
   $scope.selectedIcon = details.img;
   $scope.deviceStatus = details.status;
   $scope.deviceName = details.name;
   var s = details.status;
   $scope.deviceStatusText = (s==3 ? _str("device_status_online") :(s==2 ? _str("device_status_slow_res"): s ? _str("device_status_very_slow_res"):_str("device_status_offline")));
   $scope.statusText = (s==3 ? _str("device_status_connected_nw") :(s==2 ? _str("device_status_connected_quality"): s ? _str("device_status_unstable_connection"):_str("device_status_not_connected")));
   if(details.connectionType=="NA") details.connectionType = _str("unknown_state");
   else details.connectionType = $scope.connection_type_map[details.connectionType];
   $scope.deviceType = Object.keys($scope.device_type_map).map(function(key) { return {value:_str("device_type_"+$scope.device_type_map[key]),id:key}});
   $scope.connectionType = Object.keys($scope.connection_type_map).map(function(key) { return {value:$scope.connection_type_map[key],id:key}});
   if(details.deviceType=="NA") details.deviceType = _str("unknown_state");
   // now device types are numbers, so get display strings
   else details.deviceType = _str("device_type_"+$scope.device_type_map[details.deviceType]);
   $scope.run_test = _str("id_run_test");
   $scope.deviceDetails = [
    {header:_str("local_network_details_status"),content:$scope.statusText},
    {header: _str("local_network_details_device_name"),content:!C11N.is_portal?((details.name==details.IP)?_str("unknown_state")+" (Tap to name this device)":details.name+" ("+_str("local_network_tap_to_change")+")"):details.name,ctrl:"edit",devid:details.devid, /* TODO:hardcoded string */
     onClick: function(item){if(C11N.is_portal) return;
        H2GDIALOG.showInputTemplate(H2GDIALOG.editDeviceName_Ctrl,item);}},
    {header:_str("local_network_details_type"),content:!C11N.is_portal?(details.deviceType+" ("+_str("local_network_tap_to_select")+")"):details.deviceType,values:$scope.deviceType,devid:details.devid,
     onClick: function(item){if(C11N.is_portal) return;
        H2GDIALOG.create_customDialog(H2GDIALOG.changeType_Ctrl,item);}},
    {header: _str("local_network_details_connection"),content:!C11N.is_portal?(details.connectionType+" ("+_str("local_network_tap_to_select")+")"):details.connectionType,values:$scope.connectionType,devid:details.devid,networkId:details.currNetworkID,
     onClick: function(item){if(C11N.is_portal) return;
        H2GDIALOG.create_customDialog(H2GDIALOG.changeType_Ctrl,item);}},
    {header: _str("local_network_details_last_seen"),content:details.timeStamp,},
    {header: _str("local_network_details_monitor_device"),content:details.monitor? _str("monitor_device_on"):_str("monitor_device_off"),show:true,devid:details.devid,monitor:details.monitor},
    {header: _str("local_network_details_mac"),content:details.MAC},
    {header: _str("local_network_details_ip"),content:details.IP},
    {header: _str("local_network_details_manufacturer"),content:details.manufacturer},
    {header: _str("device_details_model"),content:details.dev_model||"NA"},
    {header: _str("id_foreground"),content:details.foreground_app||"NA"},
    {header: _str("id_battery_level"),content:details.battery_level?details.battery_level+'%':"NA"},
    {header: _str("local_network_details_responsiveness"),content:details.RTT},
    {header:_str("device_details_conn_qual"),content:details.con_qual_dbg_inf||"NA"},
    {header:_str("device_details_cpu_usage"),content:details.cpu_usage?(Math.round(details.cpu_usage)+" %"):"NA"},
    {header:_str("device_details_internet_usage"),content:details.data_usage?(DATA_UTIL.convertBytes(details.data_usage,2)+" "+_str("device_details_internet_usage_time")):"NA"},
    {header: _str("id_speed_test"),content:details.h2gApp?_str("id_speed_test_p2p_desc"):"NA",showRunTestBtn:true,devIp:details.IP,dn:details.name}
   ];
   DEVICEDETAILS.setDeviceDetails($scope.deviceDetails);
  },
  setDeviceDetails : function(dd){
   DEVICEDETAILS.devicedetails = dd;
  },
  getDeviceDetails : function(){
   return DEVICEDETAILS.devicedetails || "";
  },
  controller : function device_details_ctrl($scope){
   $scope.is_portal = C11N.is_portal;
   $scope.isItemShow = function(i){
    return (i=="NA")?true:false;
   };
   $scope.changeDeviceStatusColor = function(status) {
    return DEVICELIST.getStatusClr(status);
   };
  }
 };

export default DEVICEDETAILS;
